import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AdminAirports() {
  const [items, setItems] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState({
    code: "",
    name: "",
    city: "",
    country: "",
  });

  const loadData = async () => {
    try {
      const { data } = await api.get("/admin/master/airports");
      setItems(data);
    } catch {
      toast.error("Gagal memuat data airport");
    }
  };

  useEffect(() => {
    loadData();
  }, []);

const saveAirport = async () => {
  try {

    if (editingId) {

      await api.patch(
        `/admin/master/airports/${editingId}`,
        form
      );

      toast.success("Airport berhasil diperbarui");

    } else {

      await api.post(
        "/admin/master/airports",
        form
      );

      toast.success("Airport berhasil ditambahkan");
    }

    setForm({
      code: "",
      name: "",
      city: "",
      country: "",
    });

    setEditingId(null);

    loadData();

  } catch {
    toast.error("Gagal menyimpan airport");
  }
};

  const deleteAirport = async (id) => {
    if (!window.confirm("Hapus airport ini?")) return;

    try {
      await api.delete(`/admin/master/airports/${id}`);
      toast.success("Airport berhasil dihapus");
      loadData();
    } catch {
      toast.error("Gagal menghapus airport");
    }
  };

const editAirport = (item) => {

  setEditingId(item.id);

  setForm({
    code: item.code || "",
    name: item.name || "",
    city: item.city || "",
    country: item.country || "",
  });

  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

  return (
    <div className="w-full min-w-0 max-w-full space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Database Airports</h1>
      </div>

      <div className="grid md:grid-cols-4 gap-3">
        <input
          className="border rounded px-3 py-2"
          placeholder="Code (CGK)"
          value={form.code}
          onChange={(e) =>
            setForm({ ...form, code: e.target.value })
          }
        />

        <input
          className="border rounded px-3 py-2"
          placeholder="Airport Name"
          value={form.name}
          onChange={(e) =>
            setForm({ ...form, name: e.target.value })
          }
        />

        <input
          className="border rounded px-3 py-2"
          placeholder="City"
          value={form.city}
          onChange={(e) =>
            setForm({ ...form, city: e.target.value })
          }
        />

        <input
          className="border rounded px-3 py-2"
          placeholder="Country"
          value={form.country}
          onChange={(e) =>
            setForm({ ...form, country: e.target.value })
          }
        />
      </div>

      <button
        onClick={saveAirport}
        className="bg-blue-600 text-white px-4 py-2 rounded"
      >
        {editingId
  ? "Update Airport"
  : "Tambah Airport"}
      </button>

{editingId && (
  <button
    onClick={() => {
      setEditingId(null);

      setForm({
        code: "",
        name: "",
        city: "",
        country: "",
      });
    }}
    className="ml-3 border px-4 py-2 rounded"
  >
    Batal
  </button>
)}

      <div className="w-full max-w-full overflow-x-auto">
      <table className="w-full min-w-[640px] border">
        <thead>
          <tr className="bg-gray-100">
            <th className="border p-2">Code</th>
            <th className="border p-2">Name</th>
            <th className="border p-2">City</th>
            <th className="border p-2">Country</th>
            <th className="border p-2">Aksi</th>
          </tr>
        </thead>

        <tbody>
          {items.map((item) => (
            <tr key={item.id}>
              <td className="border p-2">{item.code}</td>
              <td className="border p-2">{item.name}</td>
              <td className="border p-2">{item.city}</td>
              <td className="border p-2">{item.country}</td>

<td className="border p-2 space-x-3">

  <button
    onClick={() => editAirport(item)}
    className="text-blue-600 font-medium"
  >
    Edit
  </button>

  <button
    onClick={() => deleteAirport(item.id)}
    className="text-red-600 font-medium"
  >
    Hapus
  </button>

</td>

            </tr>
          ))}
        </tbody>
      </table>
      </div>
    </div>
  );
}
